<template>
    <div class="">
        <events-teachers />
        <events-pupils />
        <events-eo />
    </div>
</template>


<script>
    import EventsTeachers from "./events/EventsTeachers"
    import EventsPupils from "./events/EventsPupils"
    import EventsEo from "./events/EventsEo"
    export default {
        name: "Events",
        components:{
            "events-teachers": EventsTeachers,
            "events-pupils": EventsPupils,
            "events-eo": EventsEo,
        },
        data() {
            return {
                eventsEo: [],
            }
        },
        created() {
        },
        methods: {


        }
    }
</script>


<style scoped>

</style>
